import { createFileRoute } from "@tanstack/react-router";
import { OrgDimensionSettings } from "@/components/org-dimension-settings";

// US-067 — Admin Settings: Locations master data. Thin route delegating to the
// shared OrgDimensionSettings screen (Departments shares the same component).

export const Route = createFileRoute("/settings/locations")({
  head: () => ({
    meta: [
      { title: "Locations — ProcureFlow" },
      { name: "description", content: "Manage the locations available across the workspace." },
    ],
  }),
  component: LocationsPage,
});

function LocationsPage() {
  return <OrgDimensionSettings resource="locations" title="Locations" singular="Location" />;
}
